// extracted by mini-css-extract-plugin
export var withPadding = "Layout-module--withPadding--1Rl6s";